
import instance from '../../ApiConfig';
import { URLS } from '../../ApiConfig/Urls'

const fetchAdminPayment = async () => {
    try {
        const response = await instance.get(URLS.GetAdmin+URLS.GetAdminPaymentHistory);

        if (response.status === 200) {
            return response.data;
        }

        throw new Error('Failed to fetch users');
    } catch (error) {
        throw error;
    }
};

const fetchAdminPaymentByID = async (PaymentID) => {
    try {
        const response = await instance.get(URLS.GetAdmin+URLS.GetPaymentByID + PaymentID+"/");

        if (response.status === 200) {
            return response.data;
        }

        throw new Error('Failed to fetch users');
    } catch (error) {
        throw error;
    }
};

const fetchDriverPayment = async () => {
    try {
        const response = await instance.get(URLS.GetAdmin+URLS.GetDriverPaymentHistory);

        if (response.status === 200) {
            return response.data;
        }

        throw new Error('Failed to fetch users');
    } catch (error) {
        throw error;
    }
};

const fetchDriverPaymentByID = async (PaymentID) => {
    try {
        const response = await instance.get(URLS.GetAdmin+URLS.GetDriverPaymentByID + PaymentID+"/");

        if (response.status === 200) {
            return response.data;
        }

        throw new Error('Failed to fetch users');
    } catch (error) {
        throw error;
    }
};


const fetchAdminSummary = async () => {
    try {
        const response = await instance.get( URLS.GetAdmin+URLS.GetAdminSummary);

        if (response.status === 200) {
            return response.data;
        }

        throw new Error('Failed to fetch users');
    } catch (error) {
        throw error;
    }
};
const fetchAdminPaymentByCreater = async (CreaterId) => {
    try {
        const response = await instance.get(URLS.GetServiceByCreatedBy + CreaterId+'/');

        if (response.status === 200) {
            return response.data;
        }

        throw new Error('Failed to fetch users');
    } catch (error) {
        throw error;
    }
};

const createDeposite = async (depositeData) => {
    try {
        const response = await instance.post(URLS.GetAdmin+URLS.CreateDepositeToWallet, depositeData);
        if (response.status === 201) {
            return response.data;
        }
        return null;
    } catch (error) {
        throw error
    }
}

const createRidePayement = async (rideData) => {
    try {
        const response = await instance.post(URLS.GetAdmin+URLS.CreateRidePayment, rideData);
        if (response.status === 201) {
            return response.data;
        }
        return null;
    } catch (error) {
        throw error
    }
}

const updatePayment = async (updatePaymentData, paymentID) => {

    try {
        const response = await instance.put(URLS.GetAdmin+URLS.UpdatePyment+paymentID+'/', updatePaymentData); // Adjust the URL as needed
        if (response.status === 200) {
            console.log("Vehicle Updated succfully")
            return response.data
        } else {
            return null
        }
    } catch (error) {
       throw error
    }
};


const deletePayment = async (PaymentID) => {
    try {
        const response = await instance.delete(URLS.GetAdmin+URLS.DeletePayment + PaymentID+'/');
        if (response.status === 204) {
            return response;
        }
        return null;
    } catch (error) {;
       throw error
    }
};

export default {
    fetchAdminPayment,
    fetchDriverPayment,
    fetchDriverPaymentByID,
    fetchAdminPaymentByID,
    fetchAdminSummary,
    fetchAdminPaymentByCreater,
    createDeposite,
    createRidePayement,
    updatePayment,
    deletePayment
}
